import { ifLinks, mmLinks } from 'constants/links';
import useGlobalStore from 'hooks/useGlobalStore';

export default function useBrandLinks() {
    const { isMisfitsTheme } = useGlobalStore();

    return isMisfitsTheme ? mmLinks : ifLinks;
}
